<script>
  import { household, laCounty,} from '../stores';
  import { afterUpdate } from 'svelte';
  import { __ } from '../utils/i18n'

  export let type;
</script>

<div class="error" role="alert">
  <p>
  {#if (type == "wrongAd")}
    {__('Looks like the address you entered is not a residential address. Please enter a household address.')}
  {:else if (type == "notLAC")}
    {__('Sorry, that address is not in L.A. County. Please enter an address in LAC.')}
  {/if}
  </p>
</div>
